import * as React from "react"
import { WorkforceOneUserLogOut } from "../../actions/WorkforceOneLoginActions"
import { AppState } from "../../AppState"
import { connect } from "react-redux"
import { Action, Dispatch } from "redux";
import ConfirmationModal from "../ConfirmationModal"
import { GetSelectedAssignedClinic } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"

interface RequireCompleteSetupModalProps {
  link?: string
}

interface RequireCompleteSetupModalDispatchProps {
  logout: () => void
}

export class RequireCompleteSetupModal extends React.PureComponent<RequireCompleteSetupModalProps & RequireCompleteSetupModalDispatchProps> {
  openInvitation = () =>{
    if (this.props.link) {
      this.props.logout()
      window.location.replace(this.props.link)
    }
  }

  render() {
    return <ConfirmationModal show={true}
      title="Continue Invitation Process"
      confirmButtonText="Yes"
      cancelButtonText="No"
      textTitle="Your Invitation Process has not been completed, would you like to continue?"
      text="If you chose not to continue you will be logged off."
      showImage={false}
      onConfirm={this.openInvitation}
      onHide={this.props.logout}
      showCloseButton={false} />
  }
}

function mapStateToProps(state: AppState): RequireCompleteSetupModalProps {
  return {
    link: GetSelectedAssignedClinic(state)?.Link || state.Workforce1State.link || ""
  }
}

function mapDispatchProps(dispatch: Dispatch<Action>): RequireCompleteSetupModalDispatchProps {
  return {
    logout: () => (dispatch(WorkforceOneUserLogOut(true)))
  }
}

export default connect<RequireCompleteSetupModalProps, RequireCompleteSetupModalDispatchProps, RequireCompleteSetupModalProps, AppState>(
  mapStateToProps, mapDispatchProps)(RequireCompleteSetupModal)
